// Shared rich-text parser used by editable content (Rules, Lore, etc.).
// Author syntax:
//   - blank line  → new block / paragraph spacing
//   - line starting with "- " or "• "  → bullet list item
//   - consecutive plain lines  → a single paragraph
export const parseBlocks = (text) => {
  const lines = (text || "").replace(/\r/g, "").split("\n");
  const blocks = [];
  let para = [];
  let list = [];
  const flushPara = () => { if (para.length) { blocks.push({ type: "p", text: para.join(" ") }); para = []; } };
  const flushList = () => { if (list.length) { blocks.push({ type: "list", items: list }); list = []; } };
  for (const raw of lines) {
    const line = raw.trim();
    if (!line) { flushPara(); flushList(); continue; }
    const m = line.match(/^[-•]\s+(.*)$/);
    if (m) { flushPara(); list.push(m[1]); }
    else { flushList(); para.push(line); }
  }
  flushPara();
  flushList();
  return blocks;
};

export const Bullets = ({ items }) => (
  <ul className="space-y-1.5">
    {items.map((x, i) => (
      <li key={i} className="flex gap-2.5"><span className="text-teal mt-2 h-1 w-1 rounded-full bg-teal shrink-0" /><span>{x}</span></li>
    ))}
  </ul>
);

// Renders a body string as paragraphs + bullet lists.
export const RichText = ({ text, className = "" }) => {
  const blocks = parseBlocks(text);
  return blocks.map((b, i) => (b.type === "list"
    ? <Bullets key={i} items={b.items} />
    : <p key={i} className={className}>{b.text}</p>));
};
